import React from 'react';
import './Policy.css';

function ShippingPolicy() {
  return (
    <div className="policy">
      <div className="policy-header">
        <h1>SHIPPING POLICY</h1>
        <p>learn about our shipping options and delivery times</p>
      </div>
      <div className="policy-content">
        <section>
          <h2>STANDARD SHIPPING</h2>
          <p>free standard shipping on all orders within the continental US. delivery typically takes 3-5 business days.</p>
        </section>
        <section>
          <h2>EXPRESS SHIPPING</h2>
          <p>expedited shipping available for an additional fee. delivery typically takes 1-2 business days.</p>
        </section>
        <section>
          <h2>INTERNATIONAL SHIPPING</h2>
          <p>we ship to most countries worldwide. international delivery typically takes 7-14 business days.</p>
        </section>
        <section>
          <h2>TRACKING</h2>
          <p>all orders include tracking information sent to your email address.</p>
        </section>
      </div>
    </div>
  );
}

export default ShippingPolicy; 